import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import { MyApplicationItem } from 'widgets/my-applications-list/ui/MyApplicationsItem.tsx/MyApplicationItem';

import { useUserApplicationsQuery } from 'entities/application/api';
import { ErrorImage } from 'shared/ui/ErrorImage';
import {
	CenteredContainerStyled,
	HeadingStyled,
	MyApplicationsHeaderStyled,
	MyApplicationsListStyled,
	MyApplicationsLoadingContainerStyled,
	MyAppsHeaderStyled,
	TextStyled,
	UserApplicationContainerStyled,
} from './MyApplications.styles';

export const MyApplications: FC = () => {
	const { data: userApplicationsRes, isLoading } = useUserApplicationsQuery();
	const { t } = useTranslation();

	if (isLoading) {
		return (
			<MyApplicationsLoadingContainerStyled>
				<Spin />
			</MyApplicationsLoadingContainerStyled>
		);
	}

	if (
		!userApplicationsRes ||
		(userApplicationsRes.applications.length === 0 &&
			userApplicationsRes.uninstalledApplicationsWithActiveSubscription.length === 0)
	) {
		return (
			<div style={{ width: `100%` }}>
				<MyAppsHeaderStyled>{t(`Marketplace_My_Apps`)}</MyAppsHeaderStyled>
				<CenteredContainerStyled>
					<ErrorImage src='https://cdn.dodostatic.net/static/marketplace/no-invoices' />
					<HeadingStyled>{t(`Marketplace_No_My_Apps_Heading`)}</HeadingStyled>
					<TextStyled>{t(`Marketplace_No_My_Apps_Text`)}</TextStyled>
				</CenteredContainerStyled>
			</div>
		);
	}

	return (
		<UserApplicationContainerStyled>
			{userApplicationsRes.applications.length !== 0 && (
				<>
					<MyApplicationsHeaderStyled>{t(`Marketplace_My_Apps`)}</MyApplicationsHeaderStyled>
					<MyApplicationsListStyled>
						{[
							...userApplicationsRes.uninstalledApplicationsWithActiveSubscription,
							...userApplicationsRes.applications,
						].map(n => (
							<>
								<MyApplicationItem key={n.id} applicationId={n.id} />
								{/* <MyApplicationsItemM key={n.id} applicationId={n.id} /> */}
							</>
						))}
					</MyApplicationsListStyled>
				</>
			)}
		</UserApplicationContainerStyled>
	);
};
